var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, getSelectionListContext, Icon, Spinner, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useEffectOnce } from 'react-use';
import styles from './createItem.module.scss';
import { getCreateItemContext } from './createItemContext';
/** Represents the create item. */
export const CreateItem = ({ searchTerm, refetch, children, }) => {
    const ref = useRef(null);
    const CreateItemContext = getCreateItemContext();
    const { item: itemContext } = useContext(getSelectionListContext());
    const [asyncStatus, setAsyncStatus] = useState('uninitialized');
    const [create, setCreate] = useState();
    // Handles registering the custom item with the selection list.
    useEffectOnce(() => {
        itemContext.register({ isActivatable: true });
        return () => itemContext.register({ isActivatable: false });
    });
    /** Handles creating an item. */
    const handleCreate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (create && asyncStatus !== 'pending') {
            setAsyncStatus('pending');
            const value = yield create();
            if (value) {
                // We do this in a timeout to ensure the backend is updated after which
                // we retrieve the categories anew.
                setTimeout(() => {
                    itemContext.onSelect(value);
                    refetch();
                    setAsyncStatus('fulfilled');
                }, 500);
            }
            else {
                setAsyncStatus('rejected');
            }
        }
    }), [asyncStatus, itemContext, create, refetch]);
    /** Handles the enter event after which an item should be created. */
    const handleKeydown = useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        if (event.key === 'Enter') {
            handleCreate();
        }
    }), [handleCreate]);
    // Handles the keydown event registration.
    useEffect(() => {
        if (itemContext.isActive) {
            addEventListener('keydown', handleKeydown);
        }
        else {
            removeEventListener('keydown', handleKeydown);
        }
        return () => removeEventListener('keydown', handleKeydown);
    }, [itemContext.isActive, handleKeydown]);
    // Handles scrolling the item into view when active.
    useEffect(() => {
        var _a;
        if (itemContext.isActive) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start',
            });
        }
    }, [itemContext.isActive]);
    return (_jsx(CreateItemContext.Provider, Object.assign({ value: { searchTerm, setCreate } }, { children: _jsx("li", Object.assign({ ref: ref }, { children: _jsxs(FlexBox, Object.assign({ justifyContent: "space-between", gap: "200", padding: "200 300", className: classnames(styles.root, {
                    [styles.active]: itemContext.isActive,
                }), onClick: handleCreate }, { children: [children, _jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [asyncStatus !== 'pending' && _jsx(Icon, { name: "plus" }), asyncStatus === 'pending' && _jsx(Spinner, { size: 16 })] }))] })) })) })));
};
